export const isSameEmail = (left, right) => (
  String(left || "").trim().toLowerCase() === String(right || "").trim().toLowerCase()
);

export const isValidEmailOtp = (value) => /^\d{6}$/.test(String(value || "").trim());

export const buildPublicUserSyncRow = ({ id, email, full_name, existing = null } = {}) => {
  const row = {
    id,
    email: String(email || "").trim(),
    full_name: String(full_name || "").trim(),
  };

  if (!existing) {
    row.role = "customer";
    row.status = "Active";
  }

  return row;
};

export const syncPublicUserProfile = async (supabase, { id, email, full_name } = {}) => {
  if (!id) {
    throw new Error("Missing user id. Please sign in again.");
  }

  const { data: existing, error: readError } = await supabase
    .from("users")
    .select("id")
    .eq("id", id)
    .maybeSingle();

  if (readError && readError.code !== "PGRST116") {
    throw new Error(readError.message || "Unable to read profile.");
  }

  const row = buildPublicUserSyncRow({
    id,
    email,
    full_name,
    existing: existing?.id ? existing : null,
  });

  const { error } = await supabase.from("users").upsert(row, { onConflict: "id" });
  if (error) {
    throw new Error(error.message || "Unable to sync profile to the database.");
  }
};
